import styled from '@emotion/styled';

import AllServiceSection from './AllServiceSection';
import FavoriteContainer from './FavoriteContainer';

export const GNB_TOB_BAR_HEIGHT = 40;

const GnbTopBar = () => {
  return (
    <SecondaryNavWrapper>
      <QuickAccessMenuList>
        <AllServiceSection />
        <FavoriteContainer />
      </QuickAccessMenuList>
    </SecondaryNavWrapper>
  );
};

export default GnbTopBar;

const SecondaryNavWrapper = styled('nav')`
  background-color: ${({ theme }) => theme.color['surface/global/weak/default']};
`;

const QuickAccessMenuList = styled('ul')`
  margin: 0;
  display: flex;
`;
